export class SideNavButtonModel {
  show: boolean = false;
  text: string;
  value: any;
  hoverClass: string;
}
